import { VStack } from "@chakra-ui/react"
import Hit from "@components/Search/Hit"
import ShowMore from "@components/Search/ShowMore"
import ShowPrevious from "@components/Search/ShowPrevious"
import { useInfiniteHits, UseInfiniteHitsProps } from "react-instantsearch-core"

interface HitsProps extends UseInfiniteHitsProps {
  isHome?: boolean
}

export function Hits({ isHome, ...rest }: HitsProps) {
  const { hits, isLastPage, showMore, showPrevious, isFirstPage } =
    useInfiniteHits(rest)

  return (
    <VStack
      mt={isHome ? 2 : 6}
      minH={"40vh"}
      spacing={4}
    >
      {!isFirstPage && <ShowPrevious showPrevious={showPrevious} />}

      {hits.map((hit) => (
        <Hit
          hit={hit}
          key={hit.objectID}
        />
      ))}

      {!isLastPage && (
        <ShowMore
          showMore={showMore}
          isHome={!!isHome}
        />
      )}
    </VStack>
  )
}
